// ScrollToTop.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
 const { pathname, hash } = useLocation();

 useEffect(() => {
   if (typeof window === "undefined") return;

   // If a hash is present, scroll to the element with that id
   if (hash) {
     const id = hash.replace("#", "");
     // Delay to ensure the target is rendered after route transition
     requestAnimationFrame(() => {
       const el = document.getElementById(id);
       if (el) {
         el.scrollIntoView({ behavior: "smooth", block: "start" });
       } else {
         // Fallback to top if element isn't found
         window.scrollTo({ top: 0, left: 0, behavior: "auto" });
       }
     });
     return;
   }

   // No hash: scroll to top on route change
   window.scrollTo({
     top: 0,
     left: 0,
     behavior: "auto"
   });
 }, [pathname, hash]);

 return null;
};

export default ScrollToTop;